import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateFacilityPortalMessageDto,
  FacilityPortalReplyMessageDto,
  FpMessageCreatedDto,
  FpMessagesCountsResultDto,
  FpMessagesReceivedDto,
  FpMessagesUrgencyDto,
  FpMessageTypeAndSuTypeParamsDto,
  FpReceivedMessageParamsDto,
  FpThreadMessageDto,
  FpUserPropertiesDto,
  MessageSubTypeDto,
} from 'webcommon/shared';
import { FacilityPortalHttpClientService } from '../FacilityPortalHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class FpMessagesRepository {
  constructor(
    private httpClientService: FacilityPortalHttpClientService,
  ) { }

  getFacilityPortalUserProperties(): Observable<FpUserPropertiesDto> {
    const endpointUrl = `user-properties`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  getMessageSubTypesForMessageType(messageTypeAndSubTypeParams: FpMessageTypeAndSuTypeParamsDto[]): Observable<MessageSubTypeDto[]> {
    const endpointUrl = `message-types/message-subtypes`;
    return this.httpClientService.sendPostRequest(endpointUrl, messageTypeAndSubTypeParams);
  }

  getMessageCounts(messageTypeId: string, urgencyLimit: number): Observable<FpMessagesCountsResultDto[]> {
    const params = new HttpParams();
    const endpointUrl = `message-types/${messageTypeId}/${urgencyLimit}/message-counts`;
    return this.httpClientService.sendGetRequest(endpointUrl, params);
  }

  getMessageUrgencies(urgencyLimit: number): Observable<FpMessagesUrgencyDto[]> {
    const params = new HttpParams();
    const endpointUrl = `${urgencyLimit}/message-urgencies`;
    return this.httpClientService.sendGetRequest(endpointUrl, params);
  }

  getDefaultMessageUrgency(): Observable<string> {
    const endpointUrl = `message-urgency`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  postMessage(requestDto: CreateFacilityPortalMessageDto): Observable<FpMessageCreatedDto> {
    const endpointUrl = `messages`;
    return this.httpClientService.sendPostRequest(endpointUrl, requestDto);
  }

  postReplyMessage(requestDto: FacilityPortalReplyMessageDto): Observable<FpMessageCreatedDto> {
    const endpointUrl = `messages/reply`;
    return this.httpClientService.sendPostRequest(endpointUrl, requestDto);
  }

  postCompleteMessage(requestDto: FacilityPortalReplyMessageDto): Observable<FpMessageCreatedDto> {
    const endpointUrl = `messages/complete`;
    return this.httpClientService.sendPostRequest(endpointUrl, requestDto);
  }

  getReceivedMessages(rcvMsgParams: FpReceivedMessageParamsDto): Observable<FpMessagesReceivedDto[]> {
    const endpointUrl = `messages/received/get`;
    return this.httpClientService.sendPostRequest(endpointUrl, rcvMsgParams);
  }

  getUnreadMessageCount(): Observable<number> {
    const endpointUrl = `message-count`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('read', 'false');
    return this.httpClientService.sendGetRequest(endpointUrl, httpParams);
  }

  getMessageThread(messageId: string): Observable<FpThreadMessageDto[]> {
    const endpointUrl = `messages/${messageId}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  setMessagesRead(messageId: string, threadLength: number): Observable<string> {
    const threadQueryParam = threadLength ? '?msgThreadListLength=' + threadLength : '';
    const endpointUrl = `messages/${messageId}/read${threadQueryParam}`;
    return this.httpClientService.sendPostRequest(endpointUrl, null);
  }
}
